import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

import { ROLES_ENUM } from '../../enums';
import { UserService } from '../user/user.service';

@Injectable({ providedIn: 'root' })
export class PathService {

  paths = {
    base: {
      [ROLES_ENUM.SUPER_ADMIN]: '/me',
      [ROLES_ENUM.COMPANY_ADMIN]: '/company/me',
      [ROLES_ENUM.DISPATCHER]: '/dispatchers/me',
    },
    report: {
      [ROLES_ENUM.SUPER_ADMIN]: '/company/me',
      [ROLES_ENUM.COMPANY_ADMIN]: '/company/me',
      [ROLES_ENUM.DISPATCHER]: '/dispatchers/me',
    },
    customReport: {
      [ROLES_ENUM.SUPER_ADMIN]: 'me',
      [ROLES_ENUM.COMPANY_ADMIN]: 'company/me',
      [ROLES_ENUM.DISPATCHER]: 'dispatchers/me',
    },
  };
  constructor(private readonly userService: UserService) { }

  getPath(mainPath: string) {
    return `${environment.api}${mainPath}`;
  }

  getPathByRole(mainPath: string, paths = this.paths.base) {
    const { user } = this.userService;
    const path = user && user.roleId ? paths[user.roleId] : paths[ROLES_ENUM.COMPANY_ADMIN];
    return `${environment.api}${path}${mainPath}`;
  }

  getReportPathByRole(mainPath: string) {
    return this.getPathByRole(mainPath, this.paths.report);
  }

  getCustomReportPathByRole(mainPath: string) {
    return this.getPathByRoleWithoutEnv(mainPath, this.paths.customReport);
  }

  private getPathByRoleWithoutEnv(mainPath: string, paths = this.paths.base) {
    const { user } = this.userService;
    const path = user && user.roleId ? paths[user.roleId] : paths[ROLES_ENUM.COMPANY_ADMIN];
    return `${path}${mainPath}`;
  }
}
